import { SelectOption } from "../types/system/SelectOption";

export function enumToSelectOptions(enumObj: any): SelectOption[] {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key))) // Filter out the reverse mapping keys
    .map((key, index) => ({
      value: index,
      label: key,
    }));
}
